export const clientProjectsData = [
  {
    id: 1,
    projectName: "Hotel Najma Arshi Nainital",
    projectDesc: [
      "",
      ["Freelancing Project", " Hotel based in Nainital "]
    ],
    tags: ["Vanilla JS", "Bootstrap", "Landing Page"],
    demo: "https://najmaarshi.in/",
    image:
      "./nagma_ss.png"
  },
  {
    id: 2,
    projectName: "Godrej 146 Noida",
    projectDesc: [
      `Godrej Properties has revealed its intention to attract both homebuyers and investors by offering a top-notch residential project situated in a prime location at Sector 146 in Noida.`,
      [
        ""
      ]
    ],
    tags: ["HTML", "CSS", "JavaScript", "Sheet API"],
    // code: "https://github.com/OfficialSiddharthBisht/nykaa-clone",
    demo: "https://godrej146noida.com/",
    image:
      "./godrej.webp"
  },
  {
    id: 3,
    projectName: "Ahuja Products And Services",
    projectDesc: [
      "Desktops Laptops Second Hand and repair services , provies electrical appliences and stationary",
      ["Solo Project", ""]
    ],
    tags: ["Vanilla JS", "Bootstrap", "Landing Page"],
    demo: "https://ahujaproducts.netlify.app/",
    image:
      "./ahuja.png"
  },

  // {
  //   id: 3,
  //   projectName: "E Commerce Backend NodeJS",
  //   projectDesc: [
  //     "E commerce Backend with all functionalities of an e commerce site",
  //     ["Solo Project", "Admin, User, Cart ,Filters, Search, Products, Orders"]
  //   ],
  //   tags: ["MongoDB", "Express"],
  //   code: "https://github.com/OfficialSiddharthBisht/e-commerce-backend",
  //   demo: "https://github.com/OfficialSiddharthBisht/e-commerce-backend/wiki",
  //   image:
  //     "https://th.bing.com/th/id/OIP.ndX5N2ZGLTLjQWV8gier8QHaFj?w=226&h=180&c=7&r=0&o=5&dpr=1.25&pid=1.7"
  // },
  // {
  //   id: 4,
  //   projectName: "Discovery+ Clone",
  //   projectDesc: [
  //     "Discovery+ is a streaming service.",
  //     [
  //       "JSON Server + API Endpoints",
  //       "Data Fetching using API",
  //       "Search Series Functionality"
  //     ]
  //   ],
  //   tags: ["HTML", "CSS", "JavaScript"],
  //   code: "https://github.com/OfficialSiddharthBisht/Discovery-Clone",
  //   demo: "https://officialsiddharthbisht.github.io/Discovery-Clone/",
  //   image:
  //     "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse2.mm.bing.net%2Fth%3Fid%3DOIP.dBgoyEfYljjeyDFAxa-twwHaEU%26pid%3DApi&f=1"
  // },
  // {
  //   id: 4,
  //   projectName: "React Native UI App",
  //   projectDesc: [
  //     "React native application a UI app.",
  //     [
  //       "styled components",
  //       "Images , View , SafeAreaView etc",
  //       "expo client"
  //     ]
  //   ],
  //   tags: ["React Native", "Mobile", "Android","IOS"],
  //   code: "https://github.com/OfficialSiddharthBisht/react-native-app1",
  //   demo: "https://github.com/OfficialSiddharthBisht/react-native-app1#readme",
  //   image:
  //     "https://user-images.githubusercontent.com/80667996/239228388-606a1259-6383-45cd-9db1-202e30e0175c.jpg"
  // },
  // {
  //   id: 5,
  //   projectName: "Figma Mockup",
  //   projectDesc: [
  //     "React native application a UI app.",
  //     [
  //       "styled components",
  //       "Images , View , SafeAreaView etc",
  //       "expo client"
  //     ]
  //   ],
  //   tags: ["UI/UX", "Figma","User Flow","Task Flow"],
  //   code: "https://www.figma.com/file/9GGK9LVp4F5vS64YM9cUs0/First-Mockup-E-com-v1?type=design&node-id=1-3&t=eNsx0p1YY8gX4CTm-0",
  //   demo: "https://www.figma.com/proto/9GGK9LVp4F5vS64YM9cUs0/First-Mockup-E-com-v1?type=design&node-id=1-3&scaling=scale-down&page-id=0%3A1",
  //   image:
  //     "./code.png"
  // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/